import { Injectable } from '@angular/core'
import { StatusService } from './status.service'
import { ILoginInfo, MenuItem } from '@models'
import { BaseService } from './base.service';
import { ConfigService } from './config.service';

@Injectable()
export class MenuService extends BaseService {

  items: MenuItem[] = []
  configuratorItems: MenuItem[] = []

  constructor(
    private statusServ: StatusService,
    private config: ConfigService,
  ) {
    super()
    this.statusServ.getLoginInfo()
      .subscribe(
        this.buildItems.bind(this)
      )
  }

  private buildItems(loginInfo: ILoginInfo) {
    this.items = []
    this.items.push({
      messageCode: 'MENU_ADMINISTRATION',
      faIcon: 'fas fa-cogs',
      subMenu: this.buildItemsAdministration(loginInfo)
    })

    this.items.push({
      messageCode: 'MENU_CONFIGURATOR',
      faIcon: 'fas fa-sliders-h',
      subMenu: this.buildItemsConfigurator(loginInfo)
    })

    this.items.push({
      messageCode: 'MENU_ORDERS',
      faIcon: 'fas fa-credit-card',
      subMenu: this.buildItemsOrders(loginInfo)
    })

    this.items.push({
      messageCode: 'MENU_TABLES',
      faIcon: 'fas fa-table',
      subMenu: this.buildItemsTables(loginInfo)
    })

  }

  private buildItemsAdministration(loginInfo: ILoginInfo) {
    const items = []

    if(loginInfo.is_dealer === true) {
      items.push({
        messageCode: 'ADMIN_LAYOUT',
        routerLink: [ '/admin/layout', loginInfo.dealer.id ],
        faIcon: 'fas fa-palette'
      })
    }

    if (loginInfo.is_admin === true || loginInfo.is_dealer === true)   {
      items.push({
        messageCode: 'MENU_USERS',
        routerLink: [ '/admin/users' ],
        faIcon: 'fas fa-users-cog'
      })
    }

    if (loginInfo.is_admin) {
      items.push({
        messageCode: 'MENU_DEALERS',
        routerLink: [ '/admin/company' ],
        faIcon: 'fas fa-building'
      })
    }

    if (loginInfo.is_admin === true || loginInfo.is_dealer === true)   {
      items.push({
        messageCode: 'MENU_CUSTOMERS',
        routerLink: [ '/admin/customer' ],
        faIcon: 'fas fa-industry'
      })
      items.push({
        messageCode: 'STAKEHOLDER_PRODUCTS',
        routerLink: [ '/admin/productscustomers' ],
        faIcon: 'fas fa-border-none'
      })
    }

    if (loginInfo.is_admin) {
      items.push({
        messageCode: 'MENU_LOG_BOOK',
        routerLink: [ '/admin/logbook' ],
        faIcon: 'fas fa-scroll'
      })
    }

    return items
  }


  private buildItemsOrders(loginInfo: ILoginInfo) {
    const items = []

    items.push({
      messageCode: 'MENU_ORDER_LIST',
      routerLink: [ '/orders' ],
      faIcon: 'fas fa-file-invoice'
    })

    if(!this.config.CONFIG.no_basket) {
      items.push({
        messageCode: 'MENU_VIEW_CART',
        routerLink: [ '/configurator/basket' ],
        faIcon: 'fas fa-shopping-cart'
      })
    }

    return items
  }

  private buildItemsTables(loginInfo: ILoginInfo) {
    const items = []

    if (loginInfo.is_admin) {

      items.push({
        description: 'Prodotti',
        routerLink: [ '/admin/products' ],
        faIcon: 'fas fa-cubes'
      })

      items.push({
        description: 'Parametri',
        routerLink: [ '/admin/parametri' ],
        faIcon: 'fas fa-th-list'
      })

      items.push({
        description: 'Materiali',
        routerLink: [ '/admin/materiale' ],
        faIcon: 'fas fa-table'
      })

      items.push({
        description: 'Rivestimenti Setti',
        routerLink: [ '/admin/silset/rivestimentosetti' ],
        faIcon: 'fas fa-table'
      })

      items.push({
        description: 'Spessori Setti',
        routerLink: [ '/admin/silset/spessoresetti' ],
        faIcon: 'fas fa-table'
      })

      items.push({
        description: 'Spessori',
        routerLink: [ '/admin/silset/spessorematerialeprodotto' ],
        faIcon: 'fas fa-table'
      })

      items.push({
        description: 'Traduzioni',
        routerLink: [ '/admin/translation' ],
        faIcon: 'fas fa-globe-europe'
      })

    }

    return items
  }

  private buildItemsConfigurator(loginInfo: ILoginInfo) {
    const items = []

    items.push({
      messageCode: 'MENU_CONFIGURATOR',
      routerLink: [ '/configurator/home' ],
      faIcon: 'fas fa-cogs'
    })

    if(loginInfo.is_admin === true) {
      items.push({
        messageCode: 'MENU_CONFIG_LIST',
        routerLink: [ '/configurator/list' ],
        faIcon: 'fas fa-tasks'
      })
    }

    return items
  }

  getItems(): MenuItem[] {
    return this.items
  }

}
